import Card from "components/card";
import CRMMenu from "../list-customers/components/CRMMenu";
import SleepingCustomers from "./components/Sleepingcustomers";
import { getAllTasks, getMyTasks } from "interfaces/task";
import { getUsersLight } from "interfaces/user";
import { useEffect, useState } from "react";
import TaskAgenda from "./components/TaskAgenda";

const CRMTasks = () => {
    const [tasks, setTasks] = useState<any[]>([]);
    const [users, setUsers] = useState<any[]>([]);
    const [selectedUser, setSelectedUser] = useState<string>("all");
    const [isOwner, setIsOwner] = useState(false);

    const initData = async () => {
        // Try to load all users (only works for owners)
        const usersRes = await getUsersLight();
        if (usersRes && usersRes.length > 1) {
            setIsOwner(true);
            setUsers(usersRes);
            const res = await getAllTasks();
            if (res) setTasks(res);
        } else {
            // Sub-user: load only my tasks
            const res = await getMyTasks();
            if (res) setTasks(res);
        }
    };

    const handleUserFilter = async (userId: string) => {
        setSelectedUser(userId);
        const res = await getAllTasks(userId === "all" ? undefined : userId);
        if (res) setTasks(res);
    };

    const handleTaskDone = (taskId: string) => {
        const newList = tasks.filter((t: any) => t._id !== taskId);
        setTasks(newList);
        // Update today's tasks count in localStorage
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const todayTasks = newList.filter((t: any) => {
            const taskDate = new Date(t.dueDate);
            taskDate.setHours(0, 0, 0, 0);
            return taskDate.getTime() === today.getTime();
        });
        localStorage.setItem("todayTasksNbr", todayTasks.length.toString());
    };

    const handleTaskReschedule = (taskId: string, newDueDate: string) => {
        setTasks((prev) =>
            prev.map((t: any) => (t._id === taskId ? { ...t, dueDate: newDueDate } : t))
        );
    };

    useEffect(() => {
        initData();
    }, []);

    return (
        <div>
            <CRMMenu path="/tasks" />
            <div className="mt-5">
                <Card extra={"my-5 flex w-full border"}>
                    <div className="flex items-center justify-between mx-5 mt-5 mb-4 ml-10 flex-wrap gap-3">
                        <h4 className="text-xl font-medium text-navy-700">
                            Agenda des tâches commerciales
                            <span className="ml-2 text-sm font-normal text-gray-400">
                                ({tasks.length} tâche{tasks.length > 1 ? "s" : ""} en attente)
                            </span>
                        </h4>
                        {isOwner && users.length > 0 && (
                            <div className="flex items-center gap-2">
                                <label className="text-sm text-gray-500 font-medium">
                                    Commercial :
                                </label>
                                <select
                                    value={selectedUser}
                                    onChange={(e) => handleUserFilter(e.target.value)}
                                    className="border border-gray-200 rounded-lg text-sm py-1.5 px-3 text-navy-700 bg-white focus:outline-none focus:ring-2 focus:ring-toola-400"
                                >
                                    <option value="all">Tous les commerciaux</option>
                                    {users.map((u: any) => (
                                        <option key={u._id} value={u._id}>
                                            {u.fullName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                    <div className="px-10 pb-6">
                        <TaskAgenda
                            tasks={tasks}
                            onTaskDone={handleTaskDone}
                            onTaskReschedule={handleTaskReschedule}
                        />
                    </div>
                </Card>
                <SleepingCustomers />
            </div>
        </div>
    );
};

export default CRMTasks;

